import _ from 'lodash';
import moment from 'moment';
import formatCurrency from "format-currency";
import uninvoicedTimeEntryModal from "../../../common/modals/UninvoicedTimeEntryModal/uninvoicedTimeEntryModal.component";
import invoicePreviewModal from "../../../common/modals/InvoicePreviewModal/invoicePreviewModal.component";
import travelInvoicePreviewModal from "../../../common/modals/TravelInvoicePreviewModal/travelInvoicePreviewModal.component";
import overdueByContractModal from "../../../common/modals/OverdueByContractModal/overdueByContractModal.component";

class InvoicesController {
  constructor($rootScope, $http, toastr, $q, $compile, $scope, $uibModal, AuthenticationService, $state, InvoiceService) {
    "ngInject";
    this.name = 'invoices';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    let self = this;
    this.$q = $q;
    this.uninvoicedEntriesLoaded = false;
    this.overdueInvoicesEntriesLoaded = false;
    this.recommendedInvoicesLoaded = false;
    this.recommendedInvoices = [];
    this.customerFilter = 'all';
    this.contractFilter = 'all';
    this.projectFilter = 'all';
    this.paidFilter = 'unpaid';
    this.url = $rootScope.apiHost+"/api/admin/invoices";
    this.$uibModal = $uibModal;
    this.auth = AuthenticationService;
    this.$state = $state;
    this.invoiceService = InvoiceService;
    this.selectedInvoices = [];
    this.selectedRecommendedInvoices = [];
    this.recordSize = "25";
    this.recommendedInvoiceFilterRefresh = false;
    this.recommendedInvoicesTotalCount = 0;
    this.recommendedInvoiceTableData = [];
    this.recommendedInvoiceFilter = {
      project: "0",
      contract: "0"
    };
    this.invoiceFilter = {
      paymentStatus: 'open',
      customer: "0",
      contract: "0",
      project: "0",
      invoiceDateFrom: null,
      invoiceDateTo: null,
      dueDateFrom: null,
      dueDateTo: null
    }

    this.filterrefresh = false;
    this.activeTab = 0;
    
    // Store controller reference for use in onclick handlers
    window.invoicesController = self;

    // Watch for recommended invoice table data changes to populate filter options
    $scope.$watch(function() {
      return self.recommendedInvoiceTableData;
    }, function(newData) {
      if(newData && newData.length > 0) {
        self.updateRecommendedInvoiceProjectFilterOptions(newData);
        self.updateRecommendedInvoiceContractFilterOptions(newData);
      }
    }, true);

    this.updateContractFilterOptions = function() {
      const contractColumn = self.invoiceColumns.find(function(col) {
        return col.value === 'contract.contractName';
      });
      
      if(!contractColumn || !contractColumn.filterable || !self.customers) {
        return;
      }
      
      const customerColumn = self.invoiceColumns.find(function(col) {
        return col.value === 'customer.name';
      });
      
      if(!customerColumn || !customerColumn.filterOptions) {
        return;
      }
      
      // Get selected customers
      const selectedCustomers = customerColumn.filterOptions.filter(function(opt) {
        return opt.selected && opt.id !== 0; // Exclude "All Customers" option
      });
      
      const allCustomersOption = customerColumn.filterOptions.find(function(opt) {
        return opt.id === 0;
      });
      
      // Collect all contracts from selected customers
      let allContracts = [];
      let contractMap = {}; // Use map to avoid duplicates
      
      if(allCustomersOption && allCustomersOption.selected) {
        // All customers selected - get all contracts
        self.customers.forEach(function(customer) {
          if(customer.contracts && customer.contracts.length > 0) {
            customer.contracts.forEach(function(contract) {
              const key = contract.id;
              if(!contractMap[key]) {
                contractMap[key] = contract;
                allContracts.push(contract);
              }
            });
          }
        });
      } else if(selectedCustomers.length > 0) {
        // Only selected customers
        selectedCustomers.forEach(function(customerOpt) {
          const customer = self.customers.find(function(c) {
            return c.id === customerOpt.id;
          });
          if(customer && customer.contracts && customer.contracts.length > 0) {
            customer.contracts.forEach(function(contract) {
              const key = contract.id;
              if(!contractMap[key]) {
                contractMap[key] = contract;
                allContracts.push(contract);
              }
            });
          }
        });
      } else {
        // No customers selected - show all contracts so contract filter can still work
        self.customers.forEach(function(customer) {
          if(customer.contracts && customer.contracts.length > 0) {
            customer.contracts.forEach(function(contract) {
              const key = contract.id;
              if(!contractMap[key]) {
                contractMap[key] = contract;
                allContracts.push(contract);
              }
            });
          }
        });
      }
      
      // Get current contract filter value
      const currentContractId = parseInt(self.invoiceFilter.contract) || 0;
      const currentContractIds = self.invoiceFilter.contract && self.invoiceFilter.contract !== "0" && self.invoiceFilter.contract !== "-1" 
        ? self.invoiceFilter.contract.split(',').map(function(id) { return parseInt(id); })
        : [];
      
      // Set up contract filter options
      contractColumn.filterOptions = [
        { id: 0, name: 'All Contracts', label: 'All Contracts', selected: currentContractId === 0 }
      ].concat(allContracts.map(function(contract) {
        const isSelected = currentContractId === 0 || 
                          currentContractIds.indexOf(contract.id) !== -1 ||
                          currentContractId === contract.id;
        return {
          id: contract.id,
          name: contract.contractName,
          label: contract.contractName,
          selected: isSelected
        };
      }));
      
      // Update filter state
      const selectedCount = contractColumn.filterOptions.filter(function(opt) {
        return opt.id !== 0 && opt.selected;
      }).length;
      const totalCount = contractColumn.filterOptions.length - 1; // Exclude "All" option
      contractColumn.hasActiveFilter = selectedCount < totalCount;
      
      // Set filtered count for display
      if(contractColumn.hasActiveFilter && selectedCount > 0) {
        contractColumn.filteredCount = selectedCount;
      } else {
        contractColumn.filteredCount = null;
      }
    };

    this.updateProjectFilterOptions = function() {
      const projectColumn = self.invoiceColumns.find(function(col) {
        return col.value === 'project.name';
      });
      
      if(!projectColumn || !projectColumn.filterable || !self.customers) {
        return;
      }
      
      const contractColumn = self.invoiceColumns.find(function(col) {
        return col.value === 'contract.contractName';
      });
      
      if(!contractColumn || !contractColumn.filterOptions) {
        return;
      }
      
      // Get selected contracts
      const selectedContracts = contractColumn.filterOptions.filter(function(opt) {
        return opt.selected && opt.id !== 0; // Exclude "All Contracts" option
      });
      
      const allContractsOption = contractColumn.filterOptions.find(function(opt) {
        return opt.id === 0;
      });
      
      // Collect all projects/tasks from selected contracts
      let allProjects = [];
      let projectMap = {}; // Use map to avoid duplicates
      
      if(allContractsOption && allContractsOption.selected) {
        // All contracts selected - get all projects from all customers
        self.customers.forEach(function(customer) {
          if(customer.contracts && customer.contracts.length > 0) {
            customer.contracts.forEach(function(contract) {
              if(contract.tasks && contract.tasks.length > 0) {
                contract.tasks.forEach(function(task) {
                  const key = task.id;
                  if(!projectMap[key]) {
                    projectMap[key] = task;
                    allProjects.push(task);
                  }
                });
              }
            });
          }
        });
      } else if(selectedContracts.length > 0) {
        // Only selected contracts
        selectedContracts.forEach(function(contractOpt) {
          // Find the contract in customers' contracts
          self.customers.forEach(function(customer) {
            if(customer.contracts && customer.contracts.length > 0) {
              const contract = customer.contracts.find(function(c) {
                return c.id === contractOpt.id;
              });
              if(contract && contract.tasks && contract.tasks.length > 0) {
                contract.tasks.forEach(function(task) {
                  const key = task.id;
                  if(!projectMap[key]) {
                    projectMap[key] = task;
                    allProjects.push(task);
                  }
                });
              }
            }
          });
        });
      } else {
        // No contracts selected - show all projects so project filter can still work
        self.customers.forEach(function(customer) {
          if(customer.contracts && customer.contracts.length > 0) {
            customer.contracts.forEach(function(contract) {
              if(contract.tasks && contract.tasks.length > 0) {
                contract.tasks.forEach(function(task) {
                  const key = task.id;
                  if(!projectMap[key]) {
                    projectMap[key] = task;
                    allProjects.push(task);
                  }
                });
              }
            });
          }
        });
      }
      
      // Get current project filter value
      const currentProjectId = parseInt(self.invoiceFilter.project) || 0;
      const currentProjectIds = self.invoiceFilter.project && self.invoiceFilter.project !== "0" && self.invoiceFilter.project !== "-1" 
        ? self.invoiceFilter.project.split(',').map(function(id) { return parseInt(id); })
        : [];
      
      // Set up project filter options
      projectColumn.filterOptions = [
        { id: 0, name: 'All Projects', label: 'All Projects', selected: currentProjectId === 0 }
      ].concat(allProjects.map(function(project) {
        const displayName = project.name + (project.description ? ' - ' + project.description : '');
        const isSelected = currentProjectId === 0 || 
                          currentProjectIds.indexOf(project.id) !== -1 ||
                          currentProjectId === project.id;
        return {
          id: project.id,
          name: project.name,
          label: displayName,
          selected: isSelected
        };
      }));
      
      // Update filter state
      const selectedCount = projectColumn.filterOptions.filter(function(opt) {
        return opt.id !== 0 && opt.selected;
      }).length;
      const totalCount = projectColumn.filterOptions.length - 1; // Exclude "All" option
      projectColumn.hasActiveFilter = selectedCount < totalCount;
      
      // Set filtered count for display
      if(projectColumn.hasActiveFilter && selectedCount > 0) {
        projectColumn.filteredCount = selectedCount;
      } else {
        projectColumn.filteredCount = null;
      }
    };

    this.selectInvoice = function (record, selected) {
      if(selected) {
        self.selectedInvoices.push(record);
      } else {
        _.remove(self.selectedInvoices, function (row) {
            return row.id === record.id;
        });
      }
    }

    this.getRecommendedInvoiceKey = function(record) {
      const type = (record.invoiceType || 'LABOR').toUpperCase();
      if (type === 'TRAVEL') {
        const reportIds = (record.expenseReportIds || []).slice().sort().join(',');
        return type + '|' + (record.projectId || '') + '|' + reportIds;
      }
      return type + '|' + (record.project || '') + '|' + (record.invoicePeriodStart || '') + '|' + (record.invoicePeriodEnd || '');
    }

    this.selectRecommendedInvoice = function(record, selected) {
      // Called from spring-data-table select-function
      if(selected) {
        // Check if already selected to avoid duplicates
        const key = self.getRecommendedInvoiceKey(record);
        const alreadySelected = self.selectedRecommendedInvoices.some(function(row) {
          return self.getRecommendedInvoiceKey(row) === key;
        });
        if(!alreadySelected) {
          self.selectedRecommendedInvoices.push(record);
        }
      } else {
        const key = self.getRecommendedInvoiceKey(record);
        _.remove(self.selectedRecommendedInvoices, function (row) {
          return self.getRecommendedInvoiceKey(row) === key;
        });
      }

      console.log(self.selectedRecommendedInvoices);
    }

    // Helper function to format date to YYYY-MM-DD LocalDate format
    this.formatDateToLocalDate = function(dateValue) {
      if(!dateValue) {
        return null;
      }
      
      // If it's already a string in YYYY-MM-DD format, return as-is
      if(typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        return dateValue;
      }
      
      // If it's a Date object, format it
      if(dateValue instanceof Date) {
        const year = dateValue.getFullYear();
        const month = String(dateValue.getMonth() + 1).padStart(2, '0');
        const day = String(dateValue.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
      }
      
      // If it's a string in another format, try to parse it
      if(typeof dateValue === 'string') {
        const parsedDate = new Date(dateValue);
        if(!isNaN(parsedDate.getTime())) {
          const year = parsedDate.getFullYear();
          const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
          const day = String(parsedDate.getDate()).padStart(2, '0');
          return year + '-' + month + '-' + day;
        }
      }
      
      // If we can't parse it, return null
      return null;
    }

    this.filterCriteria = function () {
      let customerParam = "customer="+self.invoiceFilter.customer;
      // If customer is an array (multiple selections), join with commas
      if(Array.isArray(self.invoiceFilter.customer)) {
        customerParam = "customer="+self.invoiceFilter.customer.join(',');
      }
      
      let contractParam = "contract="+self.invoiceFilter.contract;
      // Contract can also be comma-separated string for multiple selections
      
      let projectParam = "project="+self.invoiceFilter.project;
      // Project can also be comma-separated string for multiple selections
      
      let statusParam = "status="+(self.invoiceFilter.paymentStatus || "all");
      
      let dateParams = "";
      const invoiceDateFrom = self.formatDateToLocalDate(self.invoiceFilter.invoiceDateFrom);
      if(invoiceDateFrom) {
        dateParams += "&invoiceDateFrom="+invoiceDateFrom;
      }
      const invoiceDateTo = self.formatDateToLocalDate(self.invoiceFilter.invoiceDateTo);
      if(invoiceDateTo) {
        dateParams += "&invoiceDateTo="+invoiceDateTo;
      }
      const dueDateFrom = self.formatDateToLocalDate(self.invoiceFilter.dueDateFrom);
      if(dueDateFrom) {
        dateParams += "&dueDateFrom="+dueDateFrom;
      }
      const dueDateTo = self.formatDateToLocalDate(self.invoiceFilter.dueDateTo);
      if(dueDateTo) {
        dateParams += "&dueDateTo="+dueDateTo;
      }
      
      return customerParam+"&"+contractParam+"&"+projectParam+"&"+statusParam+dateParams;
    }

    this.invoiceColumns = [
      {
        displayName: 'Invoice Number',
        value: 'invoiceNumber',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          const label = self.formatInvoiceNumber(record);
          return "<a className=\"text-info\" target=\"_blank\" href=\"admin/invoices/"+record.id+"\" ui-sref=\"admin.invoice-details({invoiceId: "+record.id+"})\">"+label+"</a>";
        }
      },
      {
        displayName: 'Type',
        value: 'invoiceType',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return self.getInvoiceTypeLabel(record);
        }
      },
      {
        displayName: 'Customer',
        value: 'customer.name',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterOptions: [],
        filterFunction: function(column) {
          const selectedCustomers = column.filterOptions.filter(function(opt) {
            return opt.selected && opt.id !== 0; // Exclude "All Customers" option
          });
          
          const allCustomersOption = column.filterOptions.find(function(opt) {
            return opt.id === 0;
          });
          
          if(allCustomersOption && allCustomersOption.selected) {
            // "All Customers" is selected - select all and set filter to 0
            column.filterOptions.forEach(function(opt) {
              opt.selected = true;
            });
            self.invoiceFilter.customer = "0";
          } else if(selectedCustomers.length === 0) {
            // Nothing selected - show no results by setting to invalid ID
            if(allCustomersOption) {
              allCustomersOption.selected = false;
            }
            self.invoiceFilter.customer = "-1"; // Invalid ID to show no results
          } else if(selectedCustomers.length === column.filterOptions.length - 1) {
            // All customers selected (excluding "All" option) - select "All" too
            if(allCustomersOption) {
              allCustomersOption.selected = true;
            }
            self.invoiceFilter.customer = "0";
          } else if(selectedCustomers.length === 1) {
            // One customer selected
            if(allCustomersOption) {
              allCustomersOption.selected = false;
            }
            self.invoiceFilter.customer = selectedCustomers[0].id.toString();
          } else {
            // Multiple customers selected - pass all selected customer IDs as comma-separated string
            if(allCustomersOption) {
              allCustomersOption.selected = false;
            }
            const customerIds = selectedCustomers.map(function(customer) {
              return customer.id.toString();
            });
            self.invoiceFilter.customer = customerIds.join(',');
          }
          
          // Update contract filter options based on customer selection
          self.updateContractFilterOptions();
          
          // Update project filter options based on contract selection
          self.updateProjectFilterOptions();
          
          // Update dependent filters
          self.filterInvoices();
        }
      },
      {
        displayName: 'Contract',
        value: 'contract.contractName',
        sortable: true,
        sortValue: 'contract.name',
        dataType: 'text',
        filterable: true,
        filterOptions: [],
        filterFunction: function(column) {
          const selectedContracts = column.filterOptions.filter(function(opt) {
            return opt.selected && opt.id !== 0; // Exclude "All Contracts" option
          });
          
          const allContractsOption = column.filterOptions.find(function(opt) {
            return opt.id === 0;
          });
          
          if(allContractsOption && allContractsOption.selected) {
            // "All Contracts" is selected - select all and set filter to 0
            column.filterOptions.forEach(function(opt) {
              opt.selected = true;
            });
            self.invoiceFilter.contract = "0";
          } else if(selectedContracts.length === 0) {
            // Nothing selected - show no results by setting to invalid ID
            if(allContractsOption) {
              allContractsOption.selected = false;
            }
            self.invoiceFilter.contract = "-1"; // Invalid ID to show no results
          } else if(selectedContracts.length === column.filterOptions.length - 1) {
            // All contracts selected (excluding "All" option) - select "All" too
            if(allContractsOption) {
              allContractsOption.selected = true;
            }
            self.invoiceFilter.contract = "0";
          } else if(selectedContracts.length === 1) {
            // One contract selected
            if(allContractsOption) {
              allContractsOption.selected = false;
            }
            self.invoiceFilter.contract = selectedContracts[0].id.toString();
          } else {
            // Multiple contracts selected - pass all selected contract IDs as comma-separated string
            if(allContractsOption) {
              allContractsOption.selected = false;
            }
            const contractIds = selectedContracts.map(function(contract) {
              return contract.id.toString();
            });
            self.invoiceFilter.contract = contractIds.join(',');
          }
          
          // Update project filter options based on contract selection
          self.updateProjectFilterOptions();
          
          // Update dependent filters
          self.filterInvoices();
        }
      },
      {
        displayName: 'Project',
        value: 'project.name',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterOptions: [],
        filterFunction: function(column) {
          const selectedProjects = column.filterOptions.filter(function(opt) {
            return opt.selected && opt.id !== 0; // Exclude "All Projects" option
          });
          
          const allProjectsOption = column.filterOptions.find(function(opt) {
            return opt.id === 0;
          });
          
          if(allProjectsOption && allProjectsOption.selected) {
            // "All Projects" is selected - select all and set filter to 0
            column.filterOptions.forEach(function(opt) {
              opt.selected = true;
            });
            self.invoiceFilter.project = "0";
          } else if(selectedProjects.length === 0) {
            // Nothing selected - show no results by setting to invalid ID
            if(allProjectsOption) {
              allProjectsOption.selected = false;
            }
            self.invoiceFilter.project = "-1"; // Invalid ID to show no results
          } else if(selectedProjects.length === column.filterOptions.length - 1) {
            // All projects selected (excluding "All" option) - select "All" too
            if(allProjectsOption) {
              allProjectsOption.selected = true;
            }
            self.invoiceFilter.project = "0";
          } else if(selectedProjects.length === 1) {
            // One project selected
            if(allProjectsOption) {
              allProjectsOption.selected = false;
            }
            self.invoiceFilter.project = selectedProjects[0].id.toString();
          } else {
            // Multiple projects selected - pass all selected project IDs as comma-separated string
            if(allProjectsOption) {
              allProjectsOption.selected = false;
            }
            const projectIds = selectedProjects.map(function(project) {
              return project.id.toString();
            });
            self.invoiceFilter.project = projectIds.join(',');
          }
          
          // Update dependent filters
          self.filterInvoices();
        }
      },
      {
        displayName: 'Invoice Date',
        value: 'invoiceDate',
        sortValue: 'date',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterType: 'dateRange',
        dateFrom: null,
        dateTo: null,
        formatting: function (record) {
          if(!record.invoiceDate) {
            return '';
          }
          return moment(record.invoiceDate).format("MMM DD YYYY");
        },
        filterFunction: function(column) {
          // Date range filters are handled differently - store the values
          // HTML5 date inputs already return YYYY-MM-DD format
          self.invoiceFilter.invoiceDateFrom = column.dateFrom || null;
          self.invoiceFilter.invoiceDateTo = column.dateTo || null;
          self.filterInvoices();
        }
      },
      {
        displayName: 'Due Date',
        value: 'dueDate',
        dataType: 'text',
        sortable: true,
        filterable: true,
        filterType: 'dateRange',
        dateFrom: null,
        dateTo: null,
        formatting: function (record) {
          if(!record.dueDate) {
            return '';
          }
          return moment(record.dueDate).format("MMM DD YYYY");
        },
        filterFunction: function(column) {
          // Date range filters are handled differently - store the values
          // HTML5 date inputs already return YYYY-MM-DD format
          self.invoiceFilter.dueDateFrom = column.dateFrom || null;
          self.invoiceFilter.dueDateTo = column.dateTo || null;
          self.filterInvoices();
        }
      },
      {
        displayName: 'Amount',
        value: 'amount',
        dataType: 'text',
        sortable: true,
        formatting: function (record) {
          return formatCurrency(record.amount);
        }
      },
      {
        displayName: 'Open Balance',
        value: 'openBalance',
        dataType: 'text',
        sortable: true,
        formatting: function (record) {
          // If invoice hasn't been synced with Quickbooks, use amount instead of openBalance
          if(record.quickbooksId === null) {
            return formatCurrency(record.amount || 0);
          }
          return formatCurrency(record.openBalance || 0);
        }
      },
      {
        displayName: 'Status',
        value: 'paid',
        dataType: 'text',
        sortable: true,
        filterable: true,
        filterOptions: [
          { id: 'all', name: 'All', label: 'All', selected: true },
          { id: 'paid', name: 'Paid', label: 'Paid', selected: true },
          { id: 'overdue', name: 'Overdue', label: 'Overdue', selected: true },
          { id: 'open', name: 'Open', label: 'Open', selected: true }
        ],
        filterFunction: function(column) {
          const selectedStatuses = column.filterOptions.filter(function(opt) {
            return opt.selected && opt.id !== 'all';
          });
          
          const allStatusOption = column.filterOptions.find(function(opt) {
            return opt.id === 'all';
          });
          
          if(allStatusOption && allStatusOption.selected) {
            // "All" is selected - select all and set filter to "all"
            column.filterOptions.forEach(function(opt) {
              opt.selected = true;
            });
            self.invoiceFilter.paymentStatus = "all";
          } else if(selectedStatuses.length === 0) {
            // Nothing selected - show no results
            if(allStatusOption) {
              allStatusOption.selected = false;
            }
            self.invoiceFilter.paymentStatus = "none";
          } else if(selectedStatuses.length === column.filterOptions.length - 1) {
            // All statuses selected (excluding "All" option) - select "All" too
            if(allStatusOption) {
              allStatusOption.selected = true;
            }
            self.invoiceFilter.paymentStatus = "all";
          } else if(selectedStatuses.length === 1) {
            // One status selected
            if(allStatusOption) {
              allStatusOption.selected = false;
            }
            self.invoiceFilter.paymentStatus = selectedStatuses[0].id;
          } else {
            // Multiple statuses selected - use first one for now (could be enhanced)
            if(allStatusOption) {
              allStatusOption.selected = false;
            }
            self.invoiceFilter.paymentStatus = selectedStatuses[0].id;
          }
        },
        formatting: function (record) {
          return self.getInvoiceStatus(record);
        }
      },
      {
        displayName: '',
        value: '',
        dataType: 'text',
        sortable: false,
        formatting: function (record) {
          let icons = '<div style="display: flex; align-items: center; gap: 8px; justify-content: center;">';
          
          // Sync status icon
          // Check if contract has PER_CONTRACT invoice structure - allows sync even without project
          const isPerContractInvoice = record.contract && record.contract.invoiceStructure === 'PER_CONTRACT';
          
          if((!record.project || record.project.quickbooksId === null) && !isPerContractInvoice) {
            icons += '<i class="fa fa-exclamation-triangle" style="color: #f39c12; cursor: default;" title="No Project in Quickbooks"></i>';
          } else if(record.operationInProgress === true) {
            icons += '<div class="v-middle" style="display: inline-block;">' +
              '<div class="spinner" style="margin: 0px;padding: 0px;height: 20px">' +
              '<div class="rect1"></div>' +
              '<div class="rect2"></div>' +
              '<div class="rect3"></div>' +
              '<div class="rect4"></div>' +
              '<div class="rect5"></div>' +
              '</div>' +
              '</div>';
          } else if(record.quickbooksId === null) {
            icons += '<i class="fa fa-refresh" style="color: #e74c3c; cursor: pointer;" title="Not synced - Click to sync" onclick="window.invoicesController.syncSingleInvoice(' + record.id + ')"></i>';
          } else if(record.quickbooksSyncStatus === 'SUCCESS') {
            icons += '<i class="fa fa-check-circle" style="color: #27ae60; cursor: default;" title="Synced with Quickbooks"></i>';
          } else if(record.quickbooksSyncStatus && record.quickbooksSyncStatus !== 'SUCCESS') {
            icons += '<i class="fa fa-exclamation-circle" style="color: #e74c3c; cursor: pointer;" title="Sync failed: ' + (record.quickbooksSyncStatus || 'Unknown error') + '" onclick="window.invoicesController.syncSingleInvoice(' + record.id + ')"></i>';
          } else {
            icons += '<i class="fa fa-check-circle" style="color: #27ae60; cursor: default;" title="Synced with Quickbooks"></i>';
          }
          
          // Download icon (always show if invoice exists)
          if(record.id) {
            icons += '<i class="fa fa-download" style="color: #3498db; cursor: pointer;" title="Download PDF" onclick="window.invoicesController.exportInvoicePdf(' + record.id + ')"></i>';
          }
          
          // Mark as Paid icon (only show if invoice exists and is not already paid)
          if(record.id && !record.paid) {
            icons += '<i class="fa fa-dollar-sign" style="color: #27ae60; cursor: pointer;" title="Mark as Paid" onclick="window.invoicesController.markSingleInvoiceAsPaid(' + record.id + ')"></i>';
          }
          
          // Delete icon (always show if invoice exists)
          if(record.id) {
            const invoiceNumber = record.invoiceNumber || record.id || '';
            icons += '<i class="fa fa-trash" style="color: #e74c3c; cursor: pointer;" title="Delete Invoice" onclick="window.invoicesController.deleteInvoice(' + record.id + ', ' + JSON.stringify(invoiceNumber) + ')"></i>';
          }
          
          icons += '</div>';
          return icons;
        }
      }
    ];

    this.recommendedInvoiceColumns = [
      {
        displayName: 'Type',
        value: 'invoiceType',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          const type = (record.invoiceType || 'LABOR').toUpperCase();
          if (type === 'TRAVEL') {
            return '<span class="label label-success">Travel</span>';
          }
          return '<span class="label label-primary">Labor</span>';
        }
      },
      {
        displayName: 'Project',
        value: 'project',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterOptions: [],
        filterFunction: function(column) {
          const selectedProjects = column.filterOptions.filter(function(opt) {
            return opt.selected && opt.id !== 0; // Exclude "All Projects" option
          });
          
          const allProjectsOption = column.filterOptions.find(function(opt) {
            return opt.id === 0;
          });
          
          if(allProjectsOption && allProjectsOption.selected) {
            // "All Projects" is selected - select all and set filter to 0
            column.filterOptions.forEach(function(opt) {
              opt.selected = true;
            });
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.project = "0";
          } else if(selectedProjects.length === 0) {
            // Nothing selected - show no results
            if(allProjectsOption) {
              allProjectsOption.selected = false;
            }
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.project = "-1";
          } else if(selectedProjects.length === column.filterOptions.length - 1) {
            // All projects selected (excluding "All" option) - select "All" too
            if(allProjectsOption) {
              allProjectsOption.selected = true;
            }
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.project = "0";
          } else if(selectedProjects.length === 1) {
            // One project selected
            if(allProjectsOption) {
              allProjectsOption.selected = false;
            }
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.project = selectedProjects[0].id.toString();
          } else {
            // Multiple projects selected - pass all selected project IDs as comma-separated string
            if(allProjectsOption) {
              allProjectsOption.selected = false;
            }
            const projectIds = selectedProjects.map(function(project) {
              return project.id.toString();
            });
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.project = projectIds.join(',');
          }
          
          self.recommendedInvoiceFilterRefresh = true;
        },
        formatting: function (record) {
          const project = record.project || '';
          if ((record.invoiceType || 'LABOR').toUpperCase() === 'TRAVEL' && record.expenseReportName) {
            return '<a class="text-info" style="cursor: pointer;">' + project
              + ' <span class="text-muted">(' + record.expenseReportName + ')</span></a>';
          }
          return '<a class="text-info" style="cursor: pointer;">' + project + '</a>';
        },
        clickFunction: function (record) {
          self.previewInvoice(record);
        }
      },
      {
        displayName: 'Contract',
        value: 'contractName',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterOptions: [],
        filterFunction: function(column) {
          const selectedContracts = column.filterOptions.filter(function(opt) {
            return opt.selected && opt.id !== 0; // Exclude "All Contracts" option
          });
          
          const allContractsOption = column.filterOptions.find(function(opt) {
            return opt.id === 0;
          });
          
          if(allContractsOption && allContractsOption.selected) {
            // "All Contracts" is selected - select all and set filter to 0
            column.filterOptions.forEach(function(opt) {
              opt.selected = true;
            });
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.contract = "0";
          } else if(selectedContracts.length === 0) {
            // Nothing selected - show no results
            if(allContractsOption) {
              allContractsOption.selected = false;
            }
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.contract = "-1";
          } else if(selectedContracts.length === column.filterOptions.length - 1) {
            // All contracts selected (excluding "All" option) - select "All" too
            if(allContractsOption) {
              allContractsOption.selected = true;
            }
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.contract = "0";
          } else if(selectedContracts.length === 1) {
            // One contract selected
            if(allContractsOption) {
              allContractsOption.selected = false;
            }
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.contract = selectedContracts[0].id.toString();
          } else {
            // Multiple contracts selected - pass all selected contract IDs as comma-separated string
            if(allContractsOption) {
              allContractsOption.selected = false;
            }
            const contractIds = selectedContracts.map(function(contract) {
              return contract.id.toString();
            });
            self.recommendedInvoiceFilter = self.recommendedInvoiceFilter || {};
            self.recommendedInvoiceFilter.contract = contractIds.join(',');
          }
          
          self.recommendedInvoiceFilterRefresh = true;
        }
      },
      {
        displayName: 'Invoice Period',
        value: 'invoicePeriodStart',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return (record.invoicePeriodStart || '') + ' - ' + (record.invoicePeriodEnd || '');
        }
      },
      {
        displayName: 'Hours',
        value: 'hoursForInvoice',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          if ((record.invoiceType || 'LABOR').toUpperCase() === 'TRAVEL') {
            return '—';
          }
          if(record.hoursForInvoice === null || record.hoursForInvoice === undefined) {
            return '0.00';
          }
          return parseFloat(record.hoursForInvoice).toFixed(2);
        }
      },
      {
        displayName: 'Amount',
        value: 'amountOfInvoice',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatCurrency(record.amountOfInvoice);
        }
      },
      {
        displayName: 'Remaining Funding',
        value: 'remainingFunding',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatCurrency(record.remainingFunding);
        }
      },
      {
        displayName: 'Funding Available After Invoice',
        value: 'remainingFundingAfterInvoice',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          const amount = record.remainingFundingAfterInvoice || 0;
          const formatted = self.formatCurrency(amount);
          if(amount < 0) {
            return '<span style="color: #d9534f; font-weight: bold;"><i class="fa fa-exclamation-triangle"></i> ' + formatted + '</span>';
          }
          return formatted;
        }
      }
    ];

    // Filter criteria function for recommended invoices
    this.recommendedInvoiceFilterCriteria = function () {
      let projectParam = "project=" + (self.recommendedInvoiceFilter.project || "0");
      let contractParam = "contract=" + (self.recommendedInvoiceFilter.contract || "0");
      return projectParam + "&" + contractParam;
    };

    // Function to populate project filter options from recommended invoices data
    this.updateRecommendedInvoiceProjectFilterOptions = function(data) {
      if(!data || !Array.isArray(data)) {
        return;
      }
      
      const projectColumn = self.recommendedInvoiceColumns.find(function(col) {
        return col.value === 'project';
      });
      
      if(projectColumn && projectColumn.filterable) {
        // Build a map of project names to project IDs from customers/contracts/tasks
        const projectNameToIdMap = {};
        if(self.customers) {
          self.customers.forEach(function(customer) {
            if(customer.contracts && customer.contracts.length > 0) {
              customer.contracts.forEach(function(contract) {
                if(contract.tasks && contract.tasks.length > 0) {
                  contract.tasks.forEach(function(task) {
                    // Use task name as key, store task projectId
                    if(task.name && !projectNameToIdMap[task.name]) {
                      projectNameToIdMap[task.name] = task.id || task.projectId;
                    }
                  });
                }
              });
            }
          });
        }
        
        const projectMap = {};
        const projects = [];
        
        data.forEach(function(record) {
          if(record.project && !projectMap[record.project]) {
            projectMap[record.project] = true;
            // Use projectId from record if available, otherwise look it up from the map
            const projectId = record.projectId || projectNameToIdMap[record.project] || null;
            if(projectId !== null) {
              projects.push({
                id: projectId,
                name: record.project,
                label: record.project
              });
            }
          }
        });
        
        const currentProject = self.recommendedInvoiceFilter.project || "0";
        const currentProjectIds = currentProject && currentProject !== "0" && currentProject !== "-1"
          ? currentProject.split(',').map(function(id) { return parseInt(id); })
          : [];
        const currentProjectId = parseInt(currentProject) || 0;
        
        projectColumn.filterOptions = [
          { id: 0, name: 'All Projects', label: 'All Projects', selected: currentProjectId === 0 }
        ].concat(projects.map(function(project) {
          const projectIdNum = typeof project.id === 'number' ? project.id : parseInt(project.id);
          const isSelected = currentProjectId === 0 ||
                            currentProjectIds.indexOf(projectIdNum) !== -1 ||
                            currentProjectId === projectIdNum;
          return {
            id: projectIdNum,
            name: project.name,
            label: project.label,
            selected: isSelected
          };
        }));
        
        const selectedCount = projectColumn.filterOptions.filter(function(opt) {
          return opt.id !== 0 && opt.selected;
        }).length;
        const totalCount = projectColumn.filterOptions.length - 1;
        projectColumn.hasActiveFilter = selectedCount < totalCount;
        
        if(projectColumn.hasActiveFilter && selectedCount > 0) {
          projectColumn.filteredCount = selectedCount;
        } else {
          projectColumn.filteredCount = null;
        }
      }
    };

    // Function to populate contract filter options from recommended invoices data
    this.updateRecommendedInvoiceContractFilterOptions = function(data) {
      if(!data || !Array.isArray(data)) {
        return;
      }
      
      const contractColumn = self.recommendedInvoiceColumns.find(function(col) {
        return col.value === 'contractName';
      });
      
      if(contractColumn && contractColumn.filterable) {
        const contractMap = {};
        const contracts = [];
        
        data.forEach(function(record) {
          if(record.contractName && !contractMap[record.contractName]) {
            contractMap[record.contractName] = true;
            // Use contractId from record if available
            const contractId = record.contractId || null;
            if(contractId !== null) {
              contracts.push({
                id: contractId,
                name: record.contractName,
                label: record.contractName
              });
            }
          }
        });
        
        const currentContract = self.recommendedInvoiceFilter.contract || "0";
        const currentContractIds = currentContract && currentContract !== "0" && currentContract !== "-1"
          ? currentContract.split(',').map(function(id) { return parseInt(id); })
          : [];
        const currentContractId = parseInt(currentContract) || 0;
        
        contractColumn.filterOptions = [
          { id: 0, name: 'All Contracts', label: 'All Contracts', selected: currentContractId === 0 }
        ].concat(contracts.map(function(contract) {
          const contractIdNum = typeof contract.id === 'number' ? contract.id : parseInt(contract.id);
          const isSelected = currentContractId === 0 ||
                            currentContractIds.indexOf(contractIdNum) !== -1 ||
                            currentContractId === contractIdNum;
          return {
            id: contractIdNum,
            name: contract.name,
            label: contract.label,
            selected: isSelected
          };
        }));
        
        const selectedCount = contractColumn.filterOptions.filter(function(opt) {
          return opt.id !== 0 && opt.selected;
        }).length;
        const totalCount = contractColumn.filterOptions.length - 1;
        contractColumn.hasActiveFilter = selectedCount < totalCount;
        
        if(contractColumn.hasActiveFilter && selectedCount > 0) {
          contractColumn.filteredCount = selectedCount;
        } else {
          contractColumn.filteredCount = null;
        }
      }
    };

    // Function to populate contract filter options from recommended invoices data
    this.updateRecommendedInvoiceContractFilterOptions = function(data) {
      if(!data || !Array.isArray(data)) {
        return;
      }
      
      const contractColumn = self.recommendedInvoiceColumns.find(function(col) {
        return col.value === 'contractName';
      });
      
      if(contractColumn && contractColumn.filterable) {
        const contractMap = {};
        const contracts = [];
        
        data.forEach(function(record) {
          if(record.contractName && !contractMap[record.contractName]) {
            contractMap[record.contractName] = true;
            // Use contractId from record if available
            const contractId = record.contractId || null;
            if(contractId !== null) {
              contracts.push({
                id: contractId,
                name: record.contractName,
                label: record.contractName
              });
            }
          }
        });
        
        const currentContract = self.recommendedInvoiceFilter.contract || "0";
        const currentContractIds = currentContract && currentContract !== "0" && currentContract !== "-1"
          ? currentContract.split(',').map(function(id) { return parseInt(id); })
          : [];
        const currentContractId = parseInt(currentContract) || 0;
        
        contractColumn.filterOptions = [
          { id: 0, name: 'All Contracts', label: 'All Contracts', selected: currentContractId === 0 }
        ].concat(contracts.map(function(contract) {
          const contractIdNum = typeof contract.id === 'number' ? contract.id : parseInt(contract.id);
          const isSelected = currentContractId === 0 ||
                            currentContractIds.indexOf(contractIdNum) !== -1 ||
                            currentContractId === contractIdNum;
          return {
            id: contractIdNum,
            name: contract.name,
            label: contract.label,
            selected: isSelected
          };
        }));
        
        const selectedCount = contractColumn.filterOptions.filter(function(opt) {
          return opt.id !== 0 && opt.selected;
        }).length;
        const totalCount = contractColumn.filterOptions.length - 1;
        contractColumn.hasActiveFilter = selectedCount < totalCount;
        
        if(contractColumn.hasActiveFilter && selectedCount > 0) {
          contractColumn.filteredCount = selectedCount;
        } else {
          contractColumn.filteredCount = null;
        }
      }
    };

    this.$http.get($rootScope.apiHost+"/api/admin/customers/filter", {withCredentials: true}).then(function (success) {
      self.customers = success.data;
      
      // Set up customer filter options for the Customer column
      const customerColumn = self.invoiceColumns.find(function(col) {
        return col.value === 'customer.name';
      });
      
      if(customerColumn && customerColumn.filterable) {
        const currentCustomerId = parseInt(self.invoiceFilter.customer) || 0;
        
        customerColumn.filterOptions = [
          { id: 0, name: 'All Customers', label: 'All Customers', selected: currentCustomerId === 0 }
        ].concat(self.customers.map(function(customer) {
          return {
            id: customer.id,
            name: customer.name,
            label: customer.name,
            selected: currentCustomerId === 0 || currentCustomerId === customer.id
          };
        }));
        
        // Update filter state to show if filter is active
        const selectedCount = customerColumn.filterOptions.filter(function(opt) {
          return opt.id !== 0 && opt.selected;
        }).length;
        const totalCount = customerColumn.filterOptions.length - 1; // Exclude "All" option
        customerColumn.hasActiveFilter = selectedCount < totalCount;
        
        // Set filtered count for display
        if(customerColumn.hasActiveFilter && selectedCount > 0) {
          customerColumn.filteredCount = selectedCount;
        } else {
          customerColumn.filteredCount = null;
        }
        
        // Update contract filter options based on customer selection
        self.updateContractFilterOptions();
        
        // Update project filter options based on contract selection
        self.updateProjectFilterOptions();
      }
      
      // Initialize Status filter state
      const statusColumn = self.invoiceColumns.find(function(col) {
        return col.value === 'paid';
      });
      
      if(statusColumn && statusColumn.filterable && statusColumn.filterOptions) {
        const currentStatus = self.invoiceFilter.paymentStatus || 'all';
        statusColumn.filterOptions.forEach(function(opt) {
          opt.selected = (currentStatus === 'all' || opt.id === currentStatus);
        });
        
        // Update filter state
        const selectedCount = statusColumn.filterOptions.filter(function(opt) {
          return opt.id !== 'all' && opt.selected;
        }).length;
        const totalCount = statusColumn.filterOptions.length - 1;
        statusColumn.hasActiveFilter = selectedCount < totalCount;
        
        if(statusColumn.hasActiveFilter && selectedCount > 0) {
          statusColumn.filteredCount = selectedCount;
        } else {
          statusColumn.filteredCount = null;
        }
      }
      
      // Initialize date filter states
      const invoiceDateColumn = self.invoiceColumns.find(function(col) {
        return col.value === 'invoiceDate';
      });
      
      if(invoiceDateColumn && invoiceDateColumn.filterable && invoiceDateColumn.filterType === 'dateRange') {
        // HTML5 date inputs expect YYYY-MM-DD format
        invoiceDateColumn.dateFrom = self.invoiceFilter.invoiceDateFrom || null;
        invoiceDateColumn.dateTo = self.invoiceFilter.invoiceDateTo || null;
      }
      
      const dueDateColumn = self.invoiceColumns.find(function(col) {
        return col.value === 'dueDate';
      });
      
      if(dueDateColumn && dueDateColumn.filterable && dueDateColumn.filterType === 'dateRange') {
        // HTML5 date inputs expect YYYY-MM-DD format
        dueDateColumn.dateFrom = self.invoiceFilter.dueDateFrom || null;
        dueDateColumn.dateTo = self.invoiceFilter.dueDateTo || null;
      }
    });

    this.$http.get($rootScope.apiHost+"/api/admin/invoices/uninvoiced/count", {withCredentials: true}).then(function (success) {
      self.unvinvoicedHours = success.data;
      self.uninvoicedEntriesLoaded = true;
    });

    // Recommended invoices are now loaded via spring-data-table
    // Keeping this for backward compatibility if needed
    // this.$http.get($rootScope.apiHost+"/api/admin/invoices/recommendations", {withCredentials: true}).then(function (success) {
    //   self.recommendedInvoices = success.data;
    //   self.recommendedInvoicesLoaded = true;
    // });

    this.$http.get($rootScope.apiHost+"/api/admin/invoices/overdue", {withCredentials: true}).then(function (success) {
      self.overdueInvoices = success.data;
      self.overdueInvoicesEntriesLoaded = true;
    });

    this.$http.get($rootScope.apiHost+"/api/admin/invoices/open", {withCredentials: true}).then(function (success) {
      self.openInvoices = success.data;
      self.openInvoicesEntriesLoaded = true;
    });

  }




  hasPermission(perm) {
    let x = this.auth.hasPermission(perm);
    return x;
  }


  getOverdueInvoiceAmount() {
    let total = 0;
    let self = this;
    if(this.overdueInvoicesEntriesLoaded) {
      this.overdueInvoices.forEach(function (invoice) {
          total = total + invoice.amount;
      });
    }
    return '$ ' + formatCurrency(total);
  }

  filterInvoices() {
    let self = this;

    if(self.invoiceFilter.customer > 0) {
        this.customers.forEach(function (customer) {
          if (customer.id === self.invoiceFilter.customer) {
            self.customerFilter = customer;
          }
        });

        if(self.invoiceFilter.contract > 0) {

          this.customerFilter.contracts.forEach(function (contract) {
            if (contract.id === self.invoiceFilter.contract) {
              self.contractFilter = contract;
            }
          });

        } else {
          self.invoiceColumns.project = "0";
          self.contractFilter = [];
        }

    } else {
      // No customers selected - preserve contract and project filters
      // Don't reset them so they can still be used for filtering
      self.customerFilter = [];
      self.contractFilter = [];
    }


    this.filterrefresh = true;
  }


  getOpenInvoiceAmount() {
    let total = 0;
    let self = this;
    if(this.openInvoicesEntriesLoaded) {
      this.openInvoices.forEach(function (invoice) {
          // If invoice hasn't been synced with Quickbooks, use amount instead of openBalance
          if(invoice.quickbooksId === null) {
            total = total + (invoice.amount || 0);
          } else {
            total = total + (invoice.openBalance || 0);
          }
      });
    }

    return '$ ' + formatCurrency(total);
  }

  getOverdueByContract() {
    let returnVal = {};
    let self = this;

    if(this.overdueInvoicesEntriesLoaded) {
      this.overdueInvoices.forEach(function (invoice) {
          let curBal = returnVal[invoice.contract.contractName] ? returnVal[invoice.contract.contractName] : 0;
          returnVal[invoice.contract.contractName] = curBal + invoice.amount;
      });
    }

    return returnVal;
  }



  anyInvoicesSelected() {
    return this.selectedInvoices.length > 0;
  }

  showUninvoicedTimeEntries() {

    let modalInstance = this.$uibModal.open(uninvoicedTimeEntryModal);

    modalInstance.success = function () {
      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };

  }

  showOverdueByContract() {
    let self = this;
    let modalConfig = {
      template: overdueByContractModal.template,
      controller: overdueByContractModal.controller,
      controllerAs: '$ctrl',
      size: 'md',
      windowClass: "hmodal-warning animated zoomIn",
      resolve: {
        overdueByContract: function() {
          return self.getOverdueByContract();
        },
        overdueInvoicesEntriesLoaded: function() {
          return self.overdueInvoicesEntriesLoaded;
        }
      }
    };
    
    let modalInstance = this.$uibModal.open(modalConfig);

    modalInstance.result.then(function () {
      // Modal closed
    }, function () {
      // Modal dismissed
    });
  }


  previewInvoice(invoiceRecommendation) {
    if (this.isTravelRecommendation(invoiceRecommendation)) {
      this.previewTravelInvoice(invoiceRecommendation);
      return;
    }

    let modalInstance = this.$uibModal.open(invoicePreviewModal);
    modalInstance.invoiceRecommendation = invoiceRecommendation;

    modalInstance.success = function () {
      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  previewTravelInvoice(invoiceRecommendation) {
    let modalInstance = this.$uibModal.open(travelInvoicePreviewModal);
    modalInstance.invoiceRecommendation = invoiceRecommendation;

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }


  formatDate(data, type) {
    if(type === "display") {
      return moment(data).format('MMM DD, YYYY');
    } else {
      return moment(data, 'YYYY-MM-DD').toDate();
    }
  }

  getInvoiceStatus(invoice) {
    if(invoice) {
      if (invoice.paid) {
        return "Paid";
      } else {

        if (moment().startOf('day').isSame(moment(invoice.dueDate).startOf('day'))) {
          return 'Due Today';
        }

        if (moment().startOf('day').isAfter(moment(invoice.dueDate).startOf('day'))) {
          return "Overdue";
        }

        let x = moment(invoice.dueDate).startOf('day').diff(moment().startOf('day'), 'DAYS');
        return "Due in " + x + " days";
      }
    }
  }









  markAsPaid() {
    let invoiceIds = [];

    this.selectedInvoices.forEach(function (invoice){
      invoiceIds.push(invoice.id);
    });

    let self = this;
    self.$http.post(self.$rootScope.apiHost+"/api/admin/invoices/status/paid",invoiceIds, {withCredentials: true}).then(function (success) {
      self.toastr.success("Invoices Successfully Marked as Paid.", "Success!");
      let response = success.data;
      self.filterrefresh = true;
    });
  }

  markSingleInvoiceAsPaid(invoiceId) {
    let self = this;
    self.$http.post(self.$rootScope.apiHost+"/api/admin/invoices/status/paid", [invoiceId], {withCredentials: true}).then(function (success) {
      self.toastr.success("Invoice Successfully Marked as Paid.", "Success!");
      self.filterrefresh = true;
    }, function (error) {
      self.toastr.error("Error marking invoice as paid. " + (error.data ? error.data.message || error.data.error : error.statusText), "ERROR!");
    });
  }

  syncBalances() {
    let self = this;
    self.$http.get(self.$rootScope.apiHost+"/api/admin/invoices/syncbalances", {withCredentials: true}).then(function (success) {
      self.toastr.success("Balances Successfully Synchronized.", "Success!");
      self.filterrefresh = true;
    }, function (error) {
      self.toastr.error("Error Synchronizing Balances. " + (error.data ? error.data.message || error.data.error : error.statusText), "ERROR!");
    });
  }

  syncWithQb(){
    let self = this;

    self.selectedInvoices.forEach(function (invoice) {
      invoice.operationInProgress = true;
      invoice.selected = false;
    });

    self.$http.post(self.$rootScope.apiHost+"/api/integrations/qb/invoices/sync", self.selectedInvoices, {withCredentials: true}).then(function (success) {
      let response = success.data;
      response.forEach(function (invoice){
          let status = invoice.quickbooksSyncStatus;
          if(status === "SUCCESS") {
            self.toastr.success("Invoice "+invoice.invoiceNumber+" Successfully Sent To Quickbooks.", "Success!");
            invoice.operationInProgress = false;
            self.filterrefresh = true;
          } else {
            self.toastr.error("Invoice "+invoice.invoiceNumber+" Failed to Sync with Quickbooks.  Message is: " + status, "Error!");
            invoice.operationInProgress = false;
          }
      });
    }, function (error) {
      self.selectedInvoices.forEach(function (invoice) {
        invoice.operationInProgress = false;
      });
      self.toastr.error("Error Synching With Quickbooks. "+ error.data.status + " - " + error.data.error, "ERROR!");
    });


    // this.selectedInvoices = [];
  }

  getUninvoicedHours() {

  }





  formatDecimal(value){
    return formatCurrency(value);
  }


  formatCurrency(value){
    return '$ ' + formatCurrency(value);
  }

  getTotalHoursWorked(invoice) {
    let total = 0;
    if(invoice) {
      invoice.invoiceLineItems.forEach((li) => {
        total += this.getHoursWorkedForCurrentPeriod(li);
      });
    }

    return total;
  }

  getTotalCurrentDollars(invoice) {
    let total = 0;
    if(invoice && invoice.invoiceLineItems) {
      invoice.invoiceLineItems.forEach((li) => {
        total += this.getAmountForCurrentPeriod(li);
      });
    }

    return total;
  }

  getHoursWorkedForCurrentPeriod(lineItem){
    let hours = 0;
    lineItem.timeEntries.forEach((entry) => {
      hours += entry.hours;
    });
    return hours;
  }

  getTotalCumulativeDollars(invoice) {
    let total = 0;
    if(invoice) {
      invoice.invoiceLineItems.forEach((li) => {
        total += li.cumulativeDollars;
      });
    }

    return total;
  }

  getAmountForCurrentPeriod(lineItem){
    let amount = 0;
    lineItem.timeEntries.forEach((entry) => {
      amount += (entry.hours * lineItem.chargeCode.popRate.rate);
    });
    return amount;
  }

  needsQbSync(quickbooksId) {
    return quickbooksId == null;
  }

  exportInvoicePdf(invoiceId) {
    let url = this.$rootScope.apiHost+"/api/admin/invoices/"+invoiceId+"/export/pdf";
    window.open(url);
  }

  syncSingleInvoice(invoiceId) {
    let self = this;
    // Send invoice object with ID (API expects array of invoice objects)
    let invoiceObj = { id: invoiceId };
    
    self.$http.post(self.$rootScope.apiHost+"/api/integrations/qb/invoices/sync", [invoiceObj], {withCredentials: true}).then(function (success) {
      let response = success.data;
      if(response && response.length > 0) {
        let invoice = response[0];
        let status = invoice.quickbooksSyncStatus;
        if(status === "SUCCESS") {
          self.toastr.success("Invoice "+invoice.invoiceNumber+" Successfully Sent To Quickbooks.", "Success!");
        } else {
          self.toastr.error("Invoice "+invoice.invoiceNumber+" Failed to Sync with Quickbooks. Message: " + status, "Error!");
        }
      }
      // Refresh the table data
      self.filterrefresh = true;
    }, function (error) {
      self.toastr.error("Error Synching With Quickbooks. "+ (error.data ? error.data.status + " - " + error.data.error : error.statusText), "ERROR!");
    });
  }

  formatInvoiceNumber(record) {
    if (!record) {
      return '';
    }
    const number = record.invoiceNumber;
    if (record.invoiceType && String(record.invoiceType).toUpperCase() === 'TRAVEL') {
      return number + '-TRAVEL';
    }
    return String(number);
  }

  getInvoiceTypeLabel(record) {
    if (!record || !record.invoiceType) {
      return 'Labor';
    }
    const type = String(record.invoiceType).toUpperCase();
    if (type === 'TRAVEL') {
      return 'Travel';
    }
    if (type === 'OTHER') {
      return 'Other';
    }
    return 'Labor';
  }

  deleteInvoice(invoiceId, invoiceNumber) {
    let self = this;
    
    const modalTemplate = `
      <div class="inmodal">
        <div class="color-line" style="background-color: #d9534f;"></div>
        <div class="modal-header" style="background-color: #d9534f; color: #fff;">
          <h5 class="modal-title">
            <i class="fa fa-exclamation-triangle"></i> Delete Invoice
          </h5>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete invoice <strong>{{invoiceNumber}}</strong>?</p>
          <p class="text-muted">This action cannot be undone.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" ng-click="cancel()">Cancel</button>
          <button type="button" class="btn btn-danger" ng-click="confirmDelete()">
            <i class="fa fa-trash"></i> Delete Invoice
          </button>
        </div>
      </div>
    `;
    
    const modalInstance = this.$uibModal.open({
      template: modalTemplate,
      controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
        $scope.invoiceNumber = invoiceNumber || 'this invoice';
        
        $scope.confirmDelete = function() {
          $uibModalInstance.close('delete');
        };
        
        $scope.cancel = function() {
          $uibModalInstance.dismiss('cancel');
        };
      }],
      size: 'md',
      windowClass: 'hmodal-danger animated zoomIn'
    });
    
    modalInstance.result.then(function(result) {
      if (result === 'delete') {
        self.$http.delete(self.$rootScope.apiHost+"/api/admin/invoices/"+invoiceId, {withCredentials: true}).then(function (success) {
          self.toastr.success("Invoice successfully deleted.", "Success!");
          // Refresh the table data
          self.filterrefresh = true;
        }, function (error) {
          self.toastr.error("Error deleting invoice. " + (error.data ? error.data.message || error.data.error : error.statusText), "ERROR!");
        });
      }
    }, function() {
      // Modal dismissed - do nothing
    });
  }

  createRecommenedInvoice(invoiceBatch) {
    let self = this;
    this.$http.post(this.$rootScope.apiHost + '/api/admin/invoices/batch', invoiceBatch, { withCredentials: true }).then((success) => {
      if(success.data.length === 0) {
        self.recommendedInvoiceFilterRefresh = true;
        return;
      }

      // Download invoices sequentially with delays to avoid browser popup blocking
      // and reduce the number of simultaneous tabs
      success.data.forEach(function (invoice, index) {
        if(invoice.invoiceMethod !== 'AUTOMATIC') {
          setTimeout(function() {
            const url = self.$rootScope.apiHost+"/api/admin/invoices/"+invoice.id+"/export/pdf";
            // Use a hidden iframe for downloads to avoid opening tabs
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
            
            // Remove iframe after a delay
            setTimeout(function() {
              document.body.removeChild(iframe);
            }, 2000);
          }, index * 800); // 800ms delay between each download
        }
      });

      self.toastr.success(success.data.length + " Invoice(s) Successfully Created. Downloads started.", "Success!");
      self.recommendedInvoiceFilterRefresh = true;
    });
  }

  isTravelRecommendation(record) {
    return !!(record && record.invoiceType && String(record.invoiceType).toUpperCase() === 'TRAVEL');
  }

  /**
   * Resolve project id(s) for a recommended invoice.
   * PER_PROJECT recommendations have projectId > 0.
   * PER_CONTRACT recommendations use projectId 0 / "All Projects" and must expand to
   * every project on the contract so unfunded-charge checks still run.
   */
  getProjectIdsForRecommendation(record) {
    if (!record) {
      return [];
    }

    const directProjectId = Number(record.projectId);
    if (directProjectId > 0) {
      return [directProjectId];
    }

    // Contract-level recommendation: expand to all projects on the contract.
    if (record.contractId && this.customers) {
      const contractId = Number(record.contractId);
      const projectIds = [];
      const seen = {};

      this.customers.forEach(function (customer) {
        (customer.contracts || []).forEach(function (contract) {
          if (Number(contract.id) !== contractId) {
            return;
          }
          (contract.tasks || []).forEach(function (task) {
            const taskId = Number(task.id || task.projectId);
            if (taskId > 0 && !seen[taskId]) {
              seen[taskId] = true;
              projectIds.push(taskId);
            }
          });
        });
      });

      if (projectIds.length) {
        return projectIds;
      }
    }

    // Fallback: match by project name against the customer/contract tree.
    if (record.project && this.customers) {
      let matchedId = null;
      this.customers.forEach(function (customer) {
        if (matchedId) {
          return;
        }
        (customer.contracts || []).forEach(function (contract) {
          if (matchedId) {
            return;
          }
          (contract.tasks || []).forEach(function (task) {
            if (task.name === record.project) {
              matchedId = Number(task.id || task.projectId) || null;
            }
          });
        });
      });
      if (matchedId > 0) {
        return [matchedId];
      }
    }

    return [];
  }

  getProjectIdForRecommendation(record) {
    const projectIds = this.getProjectIdsForRecommendation(record);
    return projectIds.length ? projectIds[0] : null;
  }

  recommendationTouchesProject(record, projectId) {
    const targetId = Number(projectId);
    if (!targetId) {
      return false;
    }
    return this.getProjectIdsForRecommendation(record).some(function (id) {
      return Number(id) === targetId;
    });
  }

  getUniqueProjectIdsFromRecommendations(invoices) {
    const projectIds = [];
    const seen = {};

    (invoices || []).forEach((invoice) => {
      this.getProjectIdsForRecommendation(invoice).forEach((projectId) => {
        if (projectId && !seen[projectId]) {
          seen[projectId] = true;
          projectIds.push(projectId);
        }
      });
    });

    return projectIds;
  }

  fetchUnfundedChargeCodesForProjects(projectIds) {
    const self = this;

    if (!projectIds.length) {
      return this.$q.resolve([]);
    }

    const requests = projectIds.map(function(projectId) {
      return self.$http.get(
        self.$rootScope.apiHost + '/api/admin/projects/' + projectId,
        { withCredentials: true }
      ).then(function(response) {
        const project = response.data;
        const unfundedChargeCodes = project.unfundedChargeCodes || [];

        if (!unfundedChargeCodes.length) {
          return null;
        }

        return {
          projectId: project.id,
          projectName: project.name,
          unfundedChargeCodes: unfundedChargeCodes
        };
      }).catch(function() {
        return null;
      });
    });

    return this.$q.all(requests).then(function(results) {
      return results.filter(function(result) {
        return result !== null;
      });
    });
  }

  enrichWarningsWithInvoices(warnings, invoiceBatch) {
    const self = this;

    return (warnings || []).map(function(warning) {
      const affectedInvoices = (invoiceBatch || [])
        .filter(function(invoice) {
          return self.recommendationTouchesProject(invoice, warning.projectId);
        })
        .map(function(invoice) {
          return {
            invoice: invoice,
            periodLabel: (invoice.invoicePeriodStart || '') + ' - ' + (invoice.invoicePeriodEnd || '')
          };
        });

      return Object.assign({}, warning, {
        skip: true,
        affectedInvoices: affectedInvoices
      });
    });
  }

  showUnfundedChargeCodesWarning(warnings, invoiceBatch, isMultiple) {
    const enrichedWarnings = this.enrichWarningsWithInvoices(warnings, invoiceBatch);
    const recommendationTouchesProject = this.recommendationTouchesProject.bind(this);

    const modalTemplate = `
      <div class="inmodal">
        <div class="color-line" style="background-color: #f0ad4e;"></div>
        <div class="modal-header" style="background-color: #f0ad4e; color: #fff;">
          <h5 class="modal-title">
            <i class="fa fa-exclamation-triangle"></i> Some Projects have Unfunded Charges
          </h5>
        </div>
        <div class="modal-body">
          <style>
            .unfunded-invoice-warning-table th,
            .unfunded-invoice-warning-table td {
              vertical-align: top;
            }
            .unfunded-invoice-warning-table .col-project {
              width: 24%;
            }
            .unfunded-invoice-warning-table .col-action {
              width: 24%;
            }
            .unfunded-invoice-warning-table .unfunded-charge-code-list {
              padding-left: 18px;
              margin-bottom: 0;
            }
          </style>
          <p>
            The project(s) below have charge codes that have not been added to a funding line item.
            Uncheck <strong>Skip creation of this invoice</strong> to include a project in the batch.
            Other selected invoices without funding issues will still be created.
          </p>
          <div class="table-responsive">
            <table class="table table-bordered table-striped table-condensed m-b-none unfunded-invoice-warning-table">
              <thead>
                <tr>
                  <th class="col-project">Project</th>
                  <th class="col-charge-codes">Unfunded Charge Codes</th>
                  <th class="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="warning in warnings">
                  <td class="col-project" valign="top">
                    <a href="/admin/projects/{{warning.projectId}}" target="_blank" class="text-info">
                      <strong>{{warning.projectName}}</strong>
                    </a>
                    <div ng-if="warning.affectedInvoices.length" class="text-muted small m-t-xs">
                      <div ng-repeat="item in warning.affectedInvoices">{{item.periodLabel}}</div>
                    </div>
                  </td>
                  <td class="col-charge-codes" valign="top">
                    <ul class="unfunded-charge-code-list m-b-none">
                      <li ng-repeat="cc in warning.unfundedChargeCodes">
                        {{cc.first_name}} {{cc.last_name}} has charged {{cc.hours}} to {{cc.name}}
                      </li>
                    </ul>
                  </td>
                  <td class="col-action" valign="top">
                    <label class="m-b-none">
                      <input type="checkbox" ng-model="warning.skip"> Skip creation of this invoice
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="text-muted m-t-sm m-b-none">
            {{getCreateCount()}} of {{invoiceBatch.length}} selected invoice(s) will be created.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" ng-click="cancel()">Cancel</button>
          <button type="button"
                  class="btn btn-warning"
                  ng-click="confirm()"
                  ng-disabled="getCreateCount() === 0">
            {{isMultiple ? 'Create Invoice(s)' : 'Create Anyway'}}
          </button>
        </div>
      </div>
    `;

    const modalInstance = this.$uibModal.open({
      template: modalTemplate,
      controller: ['$scope', '$uibModalInstance', 'warnings', 'invoiceBatch', 'isMultiple', 'recommendationTouchesProject',
        function($scope, $uibModalInstance, warnings, invoiceBatch, isMultiple, recommendationTouchesProject) {
          $scope.warnings = warnings;
          $scope.invoiceBatch = invoiceBatch;
          $scope.isMultiple = isMultiple;

          $scope.getInvoicesToCreate = function() {
            const skippedProjectIds = {};

            warnings.forEach(function(warning) {
              if (warning.skip) {
                skippedProjectIds[warning.projectId] = true;
              }
            });

            return invoiceBatch.filter(function(invoice) {
              // Skip the invoice if it touches any project the user chose to skip.
              return !Object.keys(skippedProjectIds).some(function (projectId) {
                return recommendationTouchesProject(invoice, projectId);
              });
            });
          };

          $scope.getCreateCount = function() {
            return $scope.getInvoicesToCreate().length;
          };

          $scope.confirm = function() {
            $uibModalInstance.close($scope.getInvoicesToCreate());
          };

          $scope.cancel = function() {
            $uibModalInstance.dismiss(false);
          };
        }],
      resolve: {
        warnings: function() {
          return enrichedWarnings;
        },
        invoiceBatch: function() {
          return invoiceBatch;
        },
        isMultiple: function() {
          return isMultiple;
        },
        recommendationTouchesProject: function() {
          return recommendationTouchesProject;
        }
      },
      size: 'lg',
      windowClass: 'hmodal-warning animated zoomIn'
    });

    return modalInstance.result;
  }

  createTravelRecommendedInvoices(travelBatch) {
    const self = this;
    if (!travelBatch || !travelBatch.length) {
      return this.$q.resolve([]);
    }

    const creations = travelBatch.map((recommendation) => {
      recommendation.inCreation = true;
      const payload = {
        invoiceNumber: 0,
        invoiceDate: moment().format('YYYY-MM-DD'),
        invoicePeriodStart: moment(recommendation.invoicePeriodStart).format('YYYY-MM-DD'),
        invoicePeriodEnd: moment(recommendation.invoicePeriodEnd).format('YYYY-MM-DD'),
        signedDate: moment().format('YYYY-MM-DD'),
        customer: { id: recommendation.customerId },
        contract: { id: recommendation.contractId },
        project: { id: recommendation.projectId },
        expenseReportIds: recommendation.expenseReportIds || []
      };

      return self.invoiceService.createTravelInvoice(payload).then((success) => {
        return success.data;
      }, (error) => {
        const message = (error.data && (error.data.message || error.data.error))
          || ('Could not create travel invoice for ' + (recommendation.project || 'project') + '.');
        self.toastr.error(message, 'Travel Invoice');
        return null;
      }).finally(() => {
        recommendation.inCreation = false;
      });
    });

    return this.$q.all(creations).then((results) => {
      return (results || []).filter(Boolean);
    });
  }

  downloadCreatedInvoicePdfs(invoices) {
    const self = this;
    (invoices || []).forEach(function (invoice, index) {
      if (!invoice || !invoice.id) {
        return;
      }
      if (invoice.invoiceMethod === 'AUTOMATIC') {
        return;
      }
      setTimeout(function() {
        const url = self.$rootScope.apiHost + '/api/admin/invoices/' + invoice.id + '/export/pdf';
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        setTimeout(function() {
          document.body.removeChild(iframe);
        }, 2000);
      }, index * 800);
    });
  }

  proceedWithRecommendedInvoiceCreation(invoiceBatch) {
    const self = this;
    const laborBatch = (invoiceBatch || []).filter((invoice) => !self.isTravelRecommendation(invoice));
    const travelBatch = (invoiceBatch || []).filter((invoice) => self.isTravelRecommendation(invoice));
    const createdKeys = {};

    invoiceBatch.forEach(function(invoice) {
      createdKeys[self.getRecommendedInvoiceKey(invoice)] = true;
    });

    const laborPromise = laborBatch.length
      ? self.$http.post(self.$rootScope.apiHost + '/api/admin/invoices/batch', laborBatch, { withCredentials: true })
          .then((success) => success.data || [], (error) => {
            const message = (error.data && (error.data.message || error.data.error))
              || 'Could not create labor invoice(s).';
            self.toastr.error(message, 'ERROR');
            return [];
          })
      : self.$q.resolve([]);

    laborBatch.forEach((invoice) => {
      invoice.inCreation = true;
    });

    self.$q.all([
      laborPromise,
      self.createTravelRecommendedInvoices(travelBatch)
    ]).then((results) => {
      const laborCreated = results[0] || [];
      const travelCreated = results[1] || [];
      const allCreated = laborCreated.concat(travelCreated);

      self.downloadCreatedInvoicePdfs(allCreated);

      if (allCreated.length) {
        self.toastr.success(allCreated.length + ' Invoice(s) Successfully Created. Downloads started.', 'Success!');
      } else if (laborBatch.length || travelBatch.length) {
        self.toastr.warning('No invoices were created.', 'Warning');
      }

      self.selectedRecommendedInvoices = self.selectedRecommendedInvoices.filter(function(invoice) {
        return !createdKeys[self.getRecommendedInvoiceKey(invoice)];
      });
      self.recommendedInvoiceFilterRefresh = true;
    }).finally(() => {
      laborBatch.forEach((invoice) => {
        invoice.inCreation = false;
      });
    });
  }

  createSelectedInvoices() {
    const self = this;
    const invoiceBatch = this.selectedRecommendedInvoices.slice();

    if (!invoiceBatch.length) {
      return;
    }

    const laborBatch = invoiceBatch.filter((invoice) => !self.isTravelRecommendation(invoice));
    const travelBatch = invoiceBatch.filter((invoice) => self.isTravelRecommendation(invoice));
    const isMultiple = laborBatch.length > 1;
    const projectIds = this.getUniqueProjectIdsFromRecommendations(laborBatch);

    if (!laborBatch.length) {
      self.proceedWithRecommendedInvoiceCreation(travelBatch);
      return;
    }

    this.fetchUnfundedChargeCodesForProjects(projectIds).then(function(warnings) {
      if (!warnings.length) {
        self.proceedWithRecommendedInvoiceCreation(laborBatch.concat(travelBatch));
        return;
      }

      self.showUnfundedChargeCodesWarning(warnings, laborBatch, isMultiple).then(function(invoicesToCreate) {
        const selectedLabor = invoicesToCreate || [];
        const combined = selectedLabor.concat(travelBatch);
        if (combined.length) {
          self.proceedWithRecommendedInvoiceCreation(combined);
        } else {
          self.toastr.warning('No invoices were selected to create.', 'Cancelled');
        }
      }, function() {
        // User cancelled labor warning — still offer to create travel-only if present
        if (travelBatch.length) {
          self.proceedWithRecommendedInvoiceCreation(travelBatch);
        }
      });
    });
  }

  inCreation() {
    let x = false;
    this.recommendedInvoices.forEach(function (invoice) {
      if(invoice.inCreation) {
        x = true;
      }
    });

    return x;
  }


  anySelectedRecommendedInvoices() {
    return this.selectedRecommendedInvoices.length > 0;
  }

  getRecommendedInvoiceRowClass(record) {
    if(record.inCreation) {
      return 'info';
    }
    // Add warning class if funding available after invoice is negative
    if(record.remainingFundingAfterInvoice !== null && record.remainingFundingAfterInvoice !== undefined && record.remainingFundingAfterInvoice < 0) {
      return 'warning';
    }
    return '';
  }


}

export default InvoicesController;



// WEBPACK FOOTER //
// ./client/pages/admin/invoices/invoices.controller.js